export class LogFormatModel
{
  public showTimestamp: boolean = true;
  public showUser: boolean = true;
  public showSource: boolean = true;
  public oneLine: boolean = true;
}
